var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.77 36.3985H15.9216C15.4123 36.3985 14.999 35.9852 14.999 35.4759C14.999 34.9667 15.4123 34.5533 15.9216 34.5533H34.77C35.2793 34.5533 35.6926 34.9667 35.6926 35.4759C35.6926 35.9852 35.2793 36.3985 34.77 36.3985Z",
    fill: "#9B89EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.687 28.0779L15.4287 31.9906L19.3063 31.4103L15.687 28.0779Z",
    fill: "#9B89EE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7953 14.2177C30.5895 13.1069 28.7111 13.1844 27.6003 14.3903L16.3115 26.6496C16.3291 26.6634 16.3466 26.6773 16.3641 26.6929L20.572 30.5678C20.6099 30.6029 20.6431 30.6407 20.6717 30.6804L31.9687 18.4127C33.0795 17.2069 33.002 15.3285 31.7962 14.2177H31.7953Z",
    fill: "#9B89EE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencileIcon);
export default __webpack_public_path__ + "static/media/pencile_icon.b8de1df39a6a040d7c897c590d7311a6.svg";
export { ForwardRef as ReactComponent };